/**
 * constants.ts
 * Central location for application-wide GUID constants and derived helpers.
 * Keep all hardcoded identifiers here so they can be changed in a single place.
 */

// ---------------------------------------------------------------------------
// Empty / sentinel GUIDs
// ---------------------------------------------------------------------------

/** Standard empty GUID used as a sentinel for "no value" / super-admin context. */
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

/** Special dock GUID used when no specific dock is assigned. */
export const EMPTY_DOCK_GUID = "00000000-0000-0000-0000-000000000001";

// ---------------------------------------------------------------------------
// Sell status GUIDs excluded from stock availability calculations
// These IDs represent terminal sell states (e.g. cancelled, rejected, delivered,
// completed) whose associated goods should NOT be deducted from available stock.
// ---------------------------------------------------------------------------

export const SELL_STATUS_EXCLUDED_IDS = [
    "002E1EE2-7FD0-4CBA-9FE4-F229FA135EB7",
    "BB806733-3AF9-43FB-A898-8CC7C8F7E052",
    "AF341AC8-88A5-43CB-800C-6414B4540A45",
    "FB4F8B3F-D8F9-414C-85C3-3C3A61AA6257"
] as const;

/**
 * Pre-built SQL WHERE fragment that excludes terminal sell statuses from stock
 * calculations.  Drop it straight into a query:
 *   `"AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS ..."`
 */
export const SELL_STATUS_EXCLUDED_SQL_FILTER: string =
    SELL_STATUS_EXCLUDED_IDS
    .map(id => `AND IdListStatusSell != '${id}'`)
    .join(" ");
